import moment from 'moment'

type Value = { date: string; time: string }
export const getDateTime = (): Value => {
  const momentDate = moment(new Date())
  const date = momentDate.format('DD-MM-YYYY')
  const time = momentDate.format('HH:mm')
  return { date, time }
}
